import React from 'react';
import './OnboardingProgress.css';

const STEPS = [
  { number: 1, label: 'Goals', required: true },
  { number: 2, label: 'Profile', required: true },
  { number: 3, label: 'Skills', required: false },
  { number: 4, label: 'Finish', required: false },
];

function OnboardingProgress({ currentStep, completedSteps = [] }) {
  return (
    <div className="onboarding-progress">
      <div className="progress-container">
        {STEPS.map((step, index) => {
          const isCompleted = completedSteps.includes(step.number) || currentStep > step.number;
          const isCurrent = currentStep === step.number;
          const isUpcoming = currentStep < step.number;

          return (
            <React.Fragment key={step.number}>
              {/* Step circle */}
              <div className={`progress-step ${isCompleted ? 'completed' : ''} ${isCurrent ? 'current' : ''} ${isUpcoming ? 'upcoming' : ''}`}>
                <div className="step-circle">
                  {isCompleted ? (
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M13.5 4.5L6 12L2.5 8.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  ) : (
                    <span>{step.number}</span>
                  )}
                </div>
                <div className="step-info">
                  <span className="step-label">{step.label}</span>
                  {step.required && <span className="step-required">Required</span>}
                </div>
              </div>

              {/* Connector line */}
              {index < STEPS.length - 1 && (
                <div className={`progress-connector ${currentStep > step.number ? 'completed' : ''}`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

export default OnboardingProgress;
